import { TemplateEditViews } from '../common/types';
import { useQueryParamContext } from '../context/QueryParamContext';
import { TemplateReviewTakeoverContextProvider } from './context/TemplateReviewTakeoverContextProvider';
import { WhatsAppContext } from './context/WhatsAppContext';
import PreviewWithData from './PreviewWithData';
import { Settings } from './Settings';

const renderView = (view: string) => {
  switch (view) {
    case TemplateEditViews.preview:
      return <PreviewWithData />;
    default:
      return <Settings />;
  }
};

export const EditWhatsApp = () => {
  const { view } = useQueryParamContext();

  return (
    <WhatsAppContext>
      <TemplateReviewTakeoverContextProvider>
        {renderView(view)}
      </TemplateReviewTakeoverContextProvider>
    </WhatsAppContext>
  );
};

export default EditWhatsApp;
